/**
 * One action at a time: `run` ignores calls while the previous one is still running, and `busy` disables the button
 * meanwhile (a second click used to send the same invite, flag or note twice).
 */
import { useCallback, useRef, useState } from "react";

export function useBusy() {
  const [busy, setBusy] = useState(false);
  const running = useRef(false);
  const run = useCallback(async <T,>(fn: () => Promise<T>): Promise<T | undefined> => {
    if (running.current) return undefined;
    running.current = true;
    setBusy(true);
    try { return await fn(); } finally { running.current = false; setBusy(false); }
  }, []);
  return { busy, run };
}
